<script setup lang="ts">
    import DefaultIcon from "@/assets/actionIcons/status_kallelse_ej_skapad.svg";
    import SuccessIcon from "@/assets/actionIcons/statusgenomford.svg";
    import ErrorIcon from "@/assets/actionIcons/statusinaktiv.svg";
    import LoadingIcon from "@/assets/loader.svg";
    import { CellContentAlignment } from "@/components/KTable/helpers";
    import KCell from "@/components/KTable/KCell.vue";
    import { useStore } from "@/store";
    import { SendStatus } from "@/store/modules/recept/receptforskrivningModule";
    import { computed, toRefs } from "vue";

    const store = useStore();

    const props = defineProps<{
        data: { forskrivningId: string };
        alignContent?: CellContentAlignment;
        truncate?: boolean;
        lines?: number;
    }>();

    const { data } = toRefs(props);

    const status = computed<SendStatus>(() =>
        store.getters["receptforskrivning/statusById"]({ id: data?.value?.forskrivningId })
    );

    const allStatus: { [key in SendStatus]: { label: string; icon: string } } = {
        Default: {
            label: "Ej skickat",
            icon: DefaultIcon,
        },
        Success: {
            label: "Skickad",
            icon: SuccessIcon,
        },
        Error: {
            label: "Kunde inte skickas",
            icon: ErrorIcon,
        },
        Loading: {
            label: "Skickar...",
            icon: LoadingIcon,
        },
    };
</script>

<template>
    <KCell
        :data="data"
        class="cell-status"
        contentDirection="horizontal"
        :alignContent="alignContent"
        :truncate="truncate"
        :lines="lines"
    >
        <template #content="slotProps">
            <img
                :src="allStatus[status ?? 'Default'].icon"
                :alt="allStatus[status ?? 'default'].label"
                :class="['icon', { spin: status === 'Loading' }]"
            />
            <span>{{ allStatus[status ?? "Default"].label }}</span>
        </template>
    </KCell>
</template>

<style scoped lang="scss">
    @import "@/style/variables";

    .cell-status {
        ::v-deep .content {
            grid-gap: $icon-gap-default;
        }

        .icon {
            max-height: $line-height-default;
            width: auto;

            @keyframes spin {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }

            .spin {
                animation: spin 4s linear infinite;
            }
        }
    }
</style>
